import { Button, Flex } from '#atoms';
import useEditSurveyMutation from '#hooks/queries/onboard/useEditSurveyMutation';
import useEnrollSurveyMutation from '#hooks/queries/onboard/useEnrollSurveyMutation';
import usePatchCurrentStepMutation from '#hooks/queries/onboard/usePatchCurrentStepMutation';
import useSurveysQuery from '#hooks/queries/onboard/useSurveysQuery';
import { FloatButtonContainer } from '#molecules';
import { useToast } from '#providers/ToastProvider';
import { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import { useOnBoardStep } from '../../OnBoardStep.hooks';
import RadioItem from '../RadioItem';
import * as S from './styles';

export default function Step1() {
  const { setStep } = useOnBoardStep();
  const { data } = useSurveysQuery();
  const [selectedSurvey, setSelectedSurvey] = useState<number[]>([]);
  const { mutateAsync: enrollSurvey, isLoading: isEnrollLoading } =
    useEnrollSurveyMutation();
  const { mutateAsync: editSurvey, isLoading: isEditLoading } =
    useEditSurveyMutation();
  const { showToast } = useToast();
  const { mutateAsync: patchCurrentStep } = usePatchCurrentStepMutation();

  const handleNext = async () => {
    try {
      if (data && data.length > 0) {
        await editSurvey({ survey: 1, responses: selectedSurvey });
      } else {
        await enrollSurvey({ survey: 1, responses: selectedSurvey });
      }
      await patchCurrentStep(2);
      TagManager.dataLayer({
        dataLayer: {
          event: 'onboarding_survey_next_click',
          category: '신규가입 온보딩',
          action: 'onboarding_survey_next_click',
          value: 2
        }
      });
      setStep(2);
    } catch (err: any) {
      showToast({
        type: 'fail',
        message: '설문조사 등록에 실패했습니다. 다시 시도해주세요.'
      });
    }
  };

  const isSelected = (survey: number) => selectedSurvey.includes(survey);
  const handleClick = (survey: number) => {
    if (selectedSurvey.length === 3 && !isSelected(survey)) return;
    setSelectedSurvey(prev => {
      if (prev.includes(survey)) {
        return prev.filter(item => item !== survey);
      } else {
        return [...prev, survey];
      }
    });
  };

  useEffect(() => {
    if (data && data.length > 0) {
      setSelectedSurvey(data[0].response);
    }
  }, [data]);

  const disabled =
    isEditLoading || isEnrollLoading || selectedSurvey.length === 0;

  return (
    <>
      <S.Wrapper>
        <S.Title>트레이너로 일하시면서 {'\n'}어떤 니즈가 있으셨나요?</S.Title>
        <S.Description>니즈가 높은 순서대로 3가지를 골라주세요.</S.Description>
        <Flex direction="column" gap={8}>
          {SURVEY_LIST.map((survey, index) => {
            const selectedNumber = selectedSurvey.includes(index + 1)
              ? selectedSurvey.indexOf(index + 1) + 1
              : undefined;

            return (
              <RadioItem
                key={survey}
                title={survey}
                isSelected={isSelected(index + 1)}
                onClick={handleClick.bind(null, index + 1)}
                selectedNumber={selectedNumber}
              />
            );
          })}
        </Flex>
      </S.Wrapper>
      <FloatButtonContainer>
        <Button onClick={handleNext} disabled={disabled}>
          다음으로
        </Button>
      </FloatButtonContainer>
    </>
  );
}

const SURVEY_LIST = [
  '회원 관리를 더 쉽고 편하게 하고 싶어요',
  '나만의 프로필을 만들고 싶어요',
  '신규 회원을 유치하고 싶어요',
  '전문성을 입증하고 싶어요',
  '전문적인 트레이닝 교육을 받고 싶어요',
  '마케팅, 브랜딩 교육을 받고 싶어요'
];

const ADDITIONAL_SURVEY_LIST = [
  '채용 정보를 확인하고 싶어요',
  '이직 제안을 받아보고 싶어요'
];
